import type { HttpClient } from "../http";
import type {
  CompetitorAuthSessionDTO,
  CompetitorCrawlSummaryDTO,
  CompetitorOtpResponseDTO,
  CompetitorOtpSendRequestDTO,
  CompetitorOtpVerifyRequestDTO,
  CompetitorPlatform,
  CompetitorPriceMappingDTO,
  VendorNegotiationRequestDTO,
} from "../types";

export function competitorPricesResource(http: HttpClient) {
  return {
    listAll: () => http.get<CompetitorPriceMappingDTO[]>("/competitor-prices"),
    listBySku: (skuId: number) =>
      http.get<CompetitorPriceMappingDTO[]>(`/competitor-prices/sku/${skuId}`),
    upsertMapping: (body: CompetitorPriceMappingDTO) =>
      http.post<CompetitorPriceMappingDTO>("/competitor-prices/mapping", body),
    deleteMapping: (id: number) => http.del(`/competitor-prices/mapping/${id}`),
    autoSuggest: (skuId: number) =>
      http.post<CompetitorPriceMappingDTO[]>(`/competitor-prices/sku/${skuId}/auto-suggest`, {}),
    crawlSku: (skuId: number) =>
      http.post<CompetitorPriceMappingDTO[]>(`/competitor-prices/sku/${skuId}/crawl`, {}),
    crawlAll: () =>
      http.post<CompetitorCrawlSummaryDTO>("/competitor-prices/crawl-all", {}),
    listSessions: () =>
      http.get<CompetitorAuthSessionDTO[]>("/competitor-prices/sessions"),
    saveSession: (body: CompetitorAuthSessionDTO) =>
      http.put<CompetitorAuthSessionDTO>("/competitor-prices/sessions", body),
    keepAliveSessions: (platform?: CompetitorPlatform) =>
      http.post<CompetitorAuthSessionDTO[]>(
        `/competitor-prices/sessions/keep-alive${platform ? `?platform=${platform}` : ""}`,
        {}
      ),
    sendSessionOtp: (body: CompetitorOtpSendRequestDTO) =>
      http.post<CompetitorOtpResponseDTO>("/competitor-prices/sessions/otp/send", body),
    verifySessionOtp: (body: CompetitorOtpVerifyRequestDTO) =>
      http.post<CompetitorOtpResponseDTO>("/competitor-prices/sessions/otp/verify", body),
    negotiateWhatsApp: (body: VendorNegotiationRequestDTO) =>
      http.post<{
        skuId: number;
        skuName: string;
        vendorPhone: string;
        sentViaWhatsAppCloud: boolean;
        message: string;
      }>("/competitor-prices/negotiate-whatsapp", body),
  };
}
